import { render, staticRenderFns } from "./ExtraFeaturesSection.vue?vue&type=template&id=6da50b79&scoped=true"
import script from "./ExtraFeaturesSection.vue?vue&type=script&lang=js"
export * from "./ExtraFeaturesSection.vue?vue&type=script&lang=js"
import style0 from "./ExtraFeaturesSection.vue?vue&type=style&index=0&id=6da50b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da50b79",
  null
  
)

export default component.exports